module.exports = __webpack_public_path__ + "svg/roulette-zero.svg?ef7b317361f4c7d2ddc4607dd4b0348f";